module.exports = __webpack_public_path__ + "static/img/xinren-title.86b69c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/1yuan365new/xinren-title.png
// module id = TFv7
// module chunks = 0